// extracted by mini-css-extract-plugin
module.exports = {"title":"ListParagraph_title__1KJoz","list":"ListParagraph_list__208Ck","list__item":"ListParagraph_list__item__168Yl"};